import styled from 'styled-components';
import colors from '../../../style/colors';
import UiLink, { UiLinkProps } from '../ui-link';
import { decorations } from '../style';

type ActionLinkProps = Omit<UiLinkProps, 'variant'>;

const ActionLinkComponent = styled(UiLink)<ActionLinkProps>`
  cursor: pointer;
  ${props => props.decoration && decorations[props.decoration]};
  color: ${props => props.theme.actionColor};
  position: relative;
  font-weight: ${props => props.weight || 500};

  &:visited:not(.disabled):not([disabled]),
  &:focus:not(.disabled):not([disabled]) {
    color: ${props => props.theme.actionColor};
  }

  &:hover:not(.disabled):not([disabled]) {
    color: ${props => props.theme.actionColorDark};
  }

  &:active:not(.disabled):not([disabled]),
  &.active:not(.disabled):not([disabled]) {
    color: ${props => props.theme.actionColorDark};
  }

  &[disabled] {
    cursor: not-allowed;
    color: ${colors.gray600};
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }
`;

const ActionLink = ({ decoration = 'underline', ...rest }: ActionLinkProps) => {
  return <ActionLinkComponent decoration={decoration} {...rest} />;
};

ActionLink.displayName = 'ActionLink';

export default ActionLink;
